import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-printingidl',
  templateUrl: './printingidl.component.html',
  styleUrls: ['./printingidl.component.css']
})
export class PrintingIdlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
